import i18n from 'services/base/i18n';

export default {
  nameAppleIAP: () => i18n.pgettext('Payments|Name', 'Apple IAP'),
  nameGoogleIAP: () => i18n.pgettext('Payments|Name', 'Google IAP'),

  labelAppleIAP: () => i18n.pgettext('Payments|Label', 'Apple In-App Purchase'),
  labelGoogleIAP: () => i18n.pgettext('Payments|Label', 'Google In-App Purchase'),

  platformStripe: () => i18n.pgettext('Payments|Platform', 'Stripe'),
  platformAppleIAP: () => i18n.pgettext('Payments|Platform', 'Apple'),
  platformGoogleIAP: () => i18n.pgettext('Payments|Platform', 'Google'),
};
